export const line = (props: {[key: string]: unknown} = {}, data: { [ key: string ]: {[key: string]: any}|string[]} = {}) => {

    const isMobile: boolean = window.innerWidth <= 768;
    const overValidationChar: boolean = data.titles.some((title: string) => title.length > 5);
    let gridOptions: {[key: string]: number} = {};
    let legendOptions: any = {
        show: props.showLegend,
        type: 'scroll',
        itemStyle: data.series.length === 1 ? {color: 'transparent', borderColor: props.color, borderWidth: 1} : {},
        textStyle: {
            color: props.color
        }
    };
    
    if (props.showLegend) {
        switch (props.legendPosition) {
            case 'bottom':
                legendOptions = { ...legendOptions, bottom: 0 };
                gridOptions = { top: 25, bottom: 25, left: 3, right: 3 };
                break;
            case 'top':
                gridOptions = { bottom: 3, top: 25, left: 3, right: 3 };
                break;
        }
    } else {
        gridOptions = { top: 25, bottom: 3, right: 3, left: 3 }
    }

    return {
        xAxis: {
            type: 'category',
            data: data.titles || [],
            axisLabel: {
                fontSize: props.fontSize,
                show: props.showAxisLabels,
                width: isMobile ? 50 : 100,
                overflow: "break", 
                interval: 0,
                rotate: overValidationChar ? 45 : 0
            }
        },
        tooltip: {
            formatter: `{a}:<br>${props.prefix ? props.prefix : ''}{c}${props.suffix ? props.suffix : ''}`
        },
        yAxis: {
            type: 'value',
            boundaryGap: [ 0, 0.01 ],
            splitLine: {
                show: props.showGridlines
            },
            axisLabel: {
                formatter: `${props.prefix ? props.prefix : ''}{value}${props.suffix ? props.suffix : ''}`,
                fontSize: props.fontSize,
                show: props.showAxisLabels
            }
        },
        title: {
            show: false
        },
        textStyle: {
            color: props.color,
            fontFamily: props.fontFamily
        },
        animation: props.animation,
        series: data.series || [],
        legend: legendOptions,
        label: {
            show: props.showAnnotation,
            formatter: `${props.prefix ? props.prefix : ''}{c}${props.suffix ? props.suffix : ''}`
        },
        grid: {...gridOptions, containLabel: true}
    }
}